<template>
  <div class="phd-list">
    <vue-headful title="Список ПХД" />

    <div class="phd-list-container">
      <div class="phd-list-content">
        <message-alert :show="!!status" :message="status" :is-success="alertType === 'success'" />
        <div class="row">
          <div class="col-md-8">
            <h2>Список ПХД</h2>
          </div>
        </div>

        <hr>

        <div class="row phd-list-filters-block">
          <div class="col-sm-6 phd-list-first-filter-input-block">
            <input
              v-model="searchQuery"
              type="text"
              class="form-control"
              placeholder="Поиск по ФИО, организации или ИНН"
              @change="onSearchChange($event)"
            >
          </div>
          <div class="col-sm-6 phd-list-filter-input-block">
            <button class="btn btn-primary" @click="onAddPhd">Добавить ПХД</button>
          </div>
        </div>

        <div v-if="phdList && phdList.length">
          <div class="row">
            <div class="col-md-12">
              <div v-for="phd in phdList" :key="phd.id">
                <phd-item :phd="phd" @edit="onEditPhd" @duplicate="onDuplicatePhd" @delete="onDeletePhd" />
              </div>
            </div>
          </div>
        </div>

        <infinite-loading :identifier="infiniteId" @infinite="infiniteLoadPhdList">
          <div slot="no-more">Показаны все записи</div>
          <div slot="no-results">Нет записей</div>
        </infinite-loading>
      </div>
    </div>

    <phd-modal
      v-if="showModal"
      :phd="selectedPhd"
      @save="onSavePhd"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import '@/common/assets/styles/phd-list.scss'
import mainMixin from '@/common/mixins/mainMixin'
import { ApiClient } from '@/common/helpers/api-client/ApiClient'
import PermissionsMixin from '@/common/mixins/PermissionsMixin'
import PhdItem from '@/common/components/PhdList/PhdItem.vue'
import PhdModal from '@/common/components/PhdList/PhdModal.vue'

export default {
  name: 'PhdList',

  components: { PhdItem, PhdModal },

  mixins: [mainMixin, PermissionsMixin],

  data() {
    return {
      alertType: '',
      infiniteId: 0,
      pagination: {
        active: 1,
        per: 10
      },
      phdList: [],
      searchChanged: false,
      searchQuery: '',
      selectedPhd: null,
      showModal: false,
      status: ''
    }
  },

  computed: {
    filterParams() {
      return {
        search: this.searchQuery,
        page: this.pagination.active
      }
    }
  },

  async created() {
    // if (!this.hasPermission(PermissionsEnum.canUsePhdListPage)) {
    //   window.location.href = ApiClient.getApplicationScreenUrl()
    // }

    this.pagination.active = history.state?.page ?? 1
    await this.fetchData()
    this.hidePreloader()
  },

  methods: {
    onSearchChange(event) {
      if (this.searchChanged) return
      this.searchChanged = true
      this.searchQuery = event.target.value
      this.changeSearch()
    },

    changeSearch() {
      this.insertSearchParams()
      this.clearSearch(this.pagination.active)
      setTimeout(() => {
        this.searchChanged = false
      }, 500)
    },

    async clearSearch(page) {
      this.pagination.active = page
      this.phdList = []
      this.infiniteId += 1
    },

    async fetchData() {
      // Fetch initial data if needed
    },

    async getPagePhdList(activePage, perPage = null) {
      let results = []
      await ApiClient.getPhdList({
        page: activePage,
        perPage: perPage || this.pagination.per,
        search: this.searchQuery
      }).then((response) => {
        results = response?.data?.data?.items
      })
      return results
    },

    async infiniteLoadPhdList($state) {
      let phdList
      if (!this.phdList.length) {
        this.pagination.active = 1
      }

      phdList = await this.getPagePhdList(this.pagination.active)

      if (phdList?.length) {
        this.pagination.active++
        this.phdList.push(...phdList)
        $state.loaded()
      } else if (phdList?.length === 0) {
        $state.complete()
      } else {
        $state.error()
      }
    },

    async insertSearchParams() {
      this.pagination.active = 1
      await this.$router.push({ query: { ...this.filterParams } })
    },

    onAddPhd() {
      this.selectedPhd = null
      this.showModal = true
    },

    onEditPhd(phd) {
      this.selectedPhd = phd
      this.showModal = true
    },

    onDuplicatePhd(phd) {
      this.selectedPhd = { ...phd, id: null }
      this.showModal = true
    },

    async onDeletePhd(phd) {
      if (confirm('Удалить эту запись ПХД?')) {
        await ApiClient.deletePhd(phd.id)
        this.clearSearch(1)
      }
    },

    async onSavePhd(phdData) {
      if (phdData.id) {
        await ApiClient.updatePhd(phdData.id, phdData)
      } else {
        await ApiClient.createPhd(phdData)
      }
      this.showModal = false
      this.clearSearch(1)
    }
  }
}
</script>
